import React, { ReactNode } from 'react';
import { router, usePage, Link } from '@inertiajs/react';
import FlashMessages from '@/frontend/components/FlashMessages';

interface Props {
  children: ReactNode;
}

interface PageProps {
  auth: {
    user: {
      id: number;
      email_address: string;
    } | null;
    authenticated: boolean;
  };
  [key: string]: any;
}

export default function MainLayout({ children }: Props) {
  const { auth } = usePage<PageProps>().props;

  const handleLogout = (e: React.MouseEvent) => {
    e.preventDefault();
    router.delete('/session');
  };

  return (
    <div className="min-h-screen flex flex-col bg-muted">
      <nav className="bg-background shadow">
        <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
          <div className="relative flex justify-between h-16">
            <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
              <div className="flex-shrink-0 flex items-center">
                <Link href="/" className="flex items-center">
                  <img src="/logo-dark.png" alt="StationZero - Ir para a página inicial" className="h-7" />
                </Link>
              </div>
              <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
                <Link
                  href="/"
                  className="border-transparent text-muted-foreground hover:border-border hover:text-accent-foreground inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                >
                  Início
                </Link>
              </div>
            </div>
            <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
              {auth.authenticated ? (
                <div className="ml-3 relative">
                  <div className="flex items-center">
                    <span className="text-foreground mr-4">{auth.user?.email_address}</span>
                    <button
                      onClick={handleLogout}
                      className="bg-indigo-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      Sair
                    </button>
                  </div>
                </div>
              ) : (
                <div className="flex space-x-4">
                  <Link
                    href="/session/new"
                    className="text-muted-foreground hover:text-accent-foreground px-3 py-2 rounded-md text-sm font-medium"
                  >
                    Entrar
                  </Link>
                  <Link
                    href="/users/new"
                    className="bg-indigo-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    Cadastrar
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>

      <main className="flex-1">
        <FlashMessages />
        {children}
      </main>
    </div>
  );
}
